export type BarButton = {
    id: string;
    order: number;
    editable?: boolean;
}

export enum SquadflixHeaderType {
    TRENDING_ITEMS,
    TRENDING_MOVIES,
    TRENDING_SERIES,
    SQUADFLIX_ORIGINALS,
}

export type SquadflixHomePreferences = {
    headerType?: SquadflixHeaderType;
    showLaLigaEventsSection?: boolean;
    showNewEpisodesSection?: boolean;
    showViewLaterItems?: boolean;
    showTrendingMoviesSection?: boolean;
    showTrendingSeriesSection?: boolean;
    showLiveTvSection?: boolean;
    showSquadflixOriginalsSection?: boolean;
    showTowersStreamSection?: boolean;
}

export type AppShortcut = {
    name: string;
    url: string;
    icon: string;
    disableEdit?: boolean;
}

export type UserPreferences = {
    privateAccount?: boolean;
    hideSpoilers?: boolean;
    profileBackground?: string;
    barButtons: BarButton[];
    home: string;
    squadflixHomeCollections?: string[];
    squadflixHomePreferences?: SquadflixHomePreferences;
    shortcuts?: AppShortcut[];
    showScrollbar?: boolean;
    tvMode?: boolean;
    tvModePromptDismissed?: boolean;
}
